import { Component, Input, OnInit } from '@angular/core';
import { UntypedFormGroup } from '@angular/forms';
import { ShopPlugin } from '@pdqdev/pdq-shared/dist/interfaces';

@Component({
  selector: 'location-input-component-editor',
  templateUrl: './location-input-component-editor.component.html',
  styleUrls: ['./location-input-component-editor.component.scss'],
  standalone: false,
})
export class LocationInputComponentEditorComponent implements OnInit {
  @Input() componentForm: UntypedFormGroup;

  optionsForm: UntypedFormGroup;

  readonly locationInputType = ShopPlugin.ProductPagePromise.LocationInputType;

  ngOnInit(): void {
    this.optionsForm = this.componentForm.get('options') as UntypedFormGroup;
  }
}
